/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-dupe-keys */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { makeStyles, useMediaQuery, Select, FormControl, MenuItem, InputLabel, Typography, Paper , Dialog, IconButton, TableRow, TableCell, TableContainer, Table, TableHead, TableBody} from "@material-ui/core";
import { customTheme } from "./customTheme";
import config from "./config.json";
import moment from "moment";
import notify from './components/CustomUseNotify';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import ReactApexChart from 'react-apexcharts';
import { saveTokens } from './utils/saveTokens';
import Skeleton from '@material-ui/lab/Skeleton';
import CustomDateTimePicker from './components/CustomDateTimePickerV2';
import LiveTvIcon from "@material-ui/icons/LiveTv";
import AssessmentIcon from '@material-ui/icons/Assessment';
import CustomDateTimePickerV3 from './components/CustomDateTimePickerV3';
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {   Grid, Card, CardContent, CircularProgress } from '@material-ui/core';
import { startOfMonth, endOfMonth, format } from 'date-fns';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        maxWidth: 350
    },
    dialogButton: {
        borderRadius: 100,
        padding: "8px 25px"
    },
    dialogPaperBig: {
        borderRadius: 15,
        padding: "5px 5px 10px",
    },
    input: {
        width: "500px"
    },
    MuiInputBase: {
        root: {
            width: "800px"
        }
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
        minWidth: 100,
    },
    timeFilterContainer: {
        alignItems: "center",
        marginTop: customTheme.spacing(5),
    },
    timeFilterInput: {
        marginLeft: "2%",
    },
    outlinedInput: {
        padding: 0,
    },
    timeFilterButton: {
        marginLeft: "1%",
        width: "10%",
        minWidth: 85
    },
    summaryListRoot: {
        marginTop: customTheme.spacing(2),
    },
    summaryCardContainer: {
        display: "grid",
        gridAutoFlow: "column",
        marginTop: customTheme.spacing(3),
    },
    flexContainer: {
        display: 'flex',
        alignItems: "center",
    },
    listActions: {
        justifyContent: "space-between",
        marginTop: customTheme.spacing(3),
    },
    mainTableCell: {
        color: `${customTheme.palette.grey[900]} !important`,
        fontWeight: 500,
    },
    listVehicleIcon: {
        width: 25,
        height: 25,
        marginRight: customTheme.spacing(1),
        verticalAlign: "middle",
    },
    showLayoutMain: {
        marginTop: 0,
    },
    showTitle: {
        fontSize: 15,
        textTransform: 'uppercase',
        fontWeight: 'bold',
        color:"#334D6E"
    },
    subTitle: {
        fontSize: 12,
        textTransform: 'uppercase',
        fontWeight: 'bold'
    },
    searchParamsTitle: {
        fontSize: "1.05rem",
    },
    searchParams: {
        fontFamily: "Poppins-Regular",
        fontSize: "0.95rem",
    },
    asyncSelector: {
        display: "grid",
        gridAutoFlow: "column",
        justifyContent: "space-between",
        paddingRight: 5,
    },
    removeMargin: {
        margin: 0,
    },
    parkingListHead: {
        color: customTheme.palette.grey[500],
    },
    inlineForm: {
        display: "grid",
        gridAutoFlow: "column",
        padding: "18px 2%",
        marginLeft: 15
    },
    removeUnderline: {
        borderBottom: "none",
    },
    checkIconButton: {
        borderRadius: 4,
        padding: "5px 5px 2px",
        '&:hover': {
            backgroundColor: "#0001 !important",
            cursor: "pointer",
        },
    },
    smallSelectRoot: {
        padding: "10px 32px 10px 18px",
    },
    receiptTextContainer: {
        display: "flex",
        padding: "15px 20px",
        '&:hover': {
            backgroundColor: "#00336608",
        },
        alignItems: "center",
        marginBottom: 15,
        border: "1px solid #bfbfbf",
        borderRadius: 4,
    },
    selectWithIcon: {
        display: "flex",
        justifyContent: "space-between",
        paddingLeft: 20,
        paddingRight: "40px !important",
        columnGap: 30,
    },
    editSummaryTime: {
        color: "#888",
        fontSize: 20,
        marginLeft: 10,
        '&:hover': {
            cursor: "pointer",
            opacity: 0.7,
        }
    },
    backDrop: {
        backgroundColor: "#00000042"
    },
    statusCircle: {
        width: 7,
        height: 7,
        borderRadius: 10,
    },
    columnLink: {
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            cursor: 'pointer',
        }
    },
    timeRangeButton: {
        flex: 1,
        padding: "10px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            cursor: "pointer",
            backgroundColor: "#eee"
        }
    },
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    title: {
        fontSize: 14,
        color: customTheme.palette.secondary.main,
    },
    mainValue: {
        fontSize: 22,
        color: customTheme.palette.grey[900],
    },
    summaryBoxLabel2: {
        fontSize: 12,
        color: customTheme.palette.secondary.main,
    },
    fullWidthDialog: {
       width: '100%',
       padding: 20
    },
    chartContainer: {
        marginTop:40
    },
    headingContainer: {
        display:"flex",
        justifyContent:"space-between"
    },
    paper: {
      padding: customTheme.spacing(3),
      marginBottom: customTheme.spacing(3),
    },
    heading: {
      fontSize: 24,
      fontWeight: 'bold',
      marginBottom: customTheme.spacing(2),
    },
    subheading: {
      fontSize: 18,
      fontWeight: 'bold',
      marginTop: customTheme.spacing(2),
    },
    card: {
      marginBottom: customTheme.spacing(2),
      width: '100%', // Set the width of the small cards
      margin: customTheme.spacing(.5),
    },
    cardContent: {
      display: 'flex',
      alignItems: 'flex-start',
    },
    value: {
      fontSize: 16,
    },

});

const DashboardInsights = () => {
    //const notify = useNotify();
    const classes = useStyles();
    const location = useLocation();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [startDateTimeFilter, setStartDateTimeFilter] = useState(null);
    const [endDateTimeFilter, setEndDateTimeFilter] = useState(null);
    
    const setTimeFilters = () => {
        setStartDateTimeFilter(startDateTime);
        setEndDateTimeFilter(endDateTime);
    };
    useEffect(() => {
      const currentDate = new Date();
      const startOfMonthDate = startOfMonth(currentDate);
      const endOfMonthDate = endOfMonth(currentDate);
  
      const formattedStartDate = format(startOfMonthDate, 'yyyy-MM-dd HH:mm:ss');
      const formattedEndDate = format(endOfMonthDate, 'yyyy-MM-dd HH:mm:ss');
      setStartDateTime(formattedStartDate);
      setStartDateTimeFilter(formattedStartDate);
      setEndDateTime(formattedEndDate);
      setEndDateTimeFilter(formattedEndDate);
    }, []);
    
    return (
        <div>
            <div className='customStyleForDataSearchDiv'>
                <CustomDateTimePickerV3 startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} onChange={setTimeFilters} />
            </div>
            <div className="vehicleSummaryContainer" style={{ marginTop: 20 }} >
                <NumberOfParkingTypes/>
            </div>
            <div className="vehicleSummaryContainer" style={{ marginTop: 20 }} >
                <NumberOfControllers />
            </div>
             <div className="vehicleSummaryContainer" style={{ marginTop: 20 }} >
              <NumberOfUserAppFastagTransactions startTime={startDateTimeFilter} endTime={endDateTimeFilter} />
            </div> 
              <div className="vehicleSummaryContainer" style={{ marginTop: 20 }} >
                <NumberOfMonthlyPasses startTime={startDateTimeFilter} endTime={endDateTimeFilter} />
                <NumberOfPermitPasses startTime={startDateTimeFilter} endTime={endDateTimeFilter} />
            </div>
            <div className="vehicleSummaryContainer" style={{ marginTop: 20 }} >
                <NumberOfTransactions startTime={startDateTimeFilter} endTime={endDateTimeFilter}/>
                <NumberOfEntryExitTransactions startTime={startDateTimeFilter} endTime={endDateTimeFilter}/>
            </div>
            <div className="vehicleSummaryContainer" style={{ marginTop: 20 }} >
                <NumberOfDashboardUsers />
                <NumberOfAppUsers />
            </div>
        </div>
    )
}

function NumberOfParkings() {
    const classes = useStyles();
    const [loading, setLoading] = useState(false)
    const [insightDetails, setInsightDetails] = useState(null)

    const getInsightDetails = () => {
        const params = {user_id: sessionStorage.getItem("user_id")};
        fetch(`${config.HOST_NAME}/crm/v3/numberOfParkings?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) setInsightDetails(json.data)
                else notify(json.message, "warning");
            })
            .catch((error) => {
                notify("Something went wrong", "warning");
            })
            .finally(() => {
                setLoading(false)
            })
    };

    useEffect(() => {
      getInsightDetails()
    }, [])

    return <>
        <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px" }}>
            <div style={{ flex: 1 }}>
                <Typography className={classes.showTitle}>Sites</Typography>

                <div style={{ marginTop: 25 }}>
                    <Typography className={classes.summaryBoxLabel2}>Total</Typography>
                    {!loading && insightDetails ? <Typography className={classes.summaryBoxValue2}>{insightDetails.total_parkings}</Typography> : <Skeleton variant="text" height={36} width="34%" />}
                </div>
                <div style={{ marginTop: 25 }}>
                    <Typography className={classes.summaryBoxLabel2}>Parkings</Typography>
                    {!loading  && insightDetails ? <Typography className={classes.summaryBoxValue2}>{insightDetails.total_com_parkings}</Typography> : <Skeleton variant="text" height={36} width="34%" />}
                </div>
                <div style={{ marginTop: 25 }}>
                    <Typography className={classes.summaryBoxLabel2}>Societies</Typography>
                    {!loading  && insightDetails ? <Typography className={classes.summaryBoxValue2}>{insightDetails.total_societies}</Typography> : <Skeleton variant="text" height={36} width="34%" />}
                </div>
            </div>

           <div style={{flex: 1 }}>
				<ReactApexChart
					series={!loading  && insightDetails ? [insightDetails.total_com_parkings,insightDetails.total_societies] : [1]}
					type="donut"
					height='200'
					widht='200'
					options={{
						dataLabels: {
							enabled: false
						},
						colors: insightDetails ? ['#5E8DD3', '#FFA726'] : ['#F4F4F4'],
						chart: {
							type: 'donut',
							fontFamily: "Poppins-Regular",
						},
						legend: {
							show: false
						},
						tooltip: {
							enabled: true,
							style: {
								fontSize: '12px',
								fontFamily: "Poppins-Regular"
							},
							marker: {
								show: true,
							},
						}
					}}
				/>
				
				{!insightDetails && <p style={{ fontSize: 10, color: '#9e9e9e' }}>Data not available.</p>}
			</div>
        </Paper>
    </> 
}

function NumberOfVehicles() {
    const classes = useStyles();
    const [loading, setLoading] = useState(false)
    const [insightDetails, setInsightDetails] = useState(null)

    const getInsightDetails = () => {
        const params = {user_id: sessionStorage.getItem("user_id")};
        fetch(`${config.HOST_NAME}/crm/v3/numberOfParkings?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) setInsightDetails(json.data)
                else notify(json.message, "warning");
            })
            .catch((error) => {
                notify("Something went wrong", "warning");
            })
            .finally(() => {
                setLoading(false)
            })
    };

    useEffect(() => {
      getInsightDetails()
    }, [])

    return <>
        <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px" }}>
            <div style={{ flex: 1 }}>
                <Typography className={classes.showTitle}>VEHICLES</Typography>

                <div style={{ marginTop: 25 }}>
                    <Typography className={classes.summaryBoxLabel2}>No. of Vehicles</Typography>
                    {!loading && insightDetails ? <Typography className={classes.summaryBoxValue2}>{insightDetails.total_parkings}</Typography> : <Skeleton variant="text" height={36} width="34%" />}
                </div>
                <div style={{ marginTop: 25 }}>
                    <Typography className={classes.summaryBoxLabel2}>No. of FASTag</Typography>
                    {!loading  && insightDetails ? <Typography className={classes.summaryBoxValue2}>{insightDetails.total_com_parkings}</Typography> : <Skeleton variant="text" height={36} width="34%" />}
                </div>
                
            </div>

           <div style={{flex: 1 }}>
				<ReactApexChart
					series={!loading  && insightDetails ? [insightDetails.total_com_parkings,insightDetails.total_societies] : [1]}
					type="donut"
					height='200'
					widht='200'
					options={{
						dataLabels: {
							enabled: false
						},
						colors: insightDetails ? ['#5E8DD3', '#FFA726'] : ['#F4F4F4'],
						chart: {
							type: 'donut',
							fontFamily: "Poppins-Regular",
						},
						legend: {
							show: false
						},
						tooltip: {
							enabled: true,
							style: {
								fontSize: '12px',
								fontFamily: "Poppins-Regular"
							},
							marker: {
								show: true,
							},
						}
					}}
				/>
				
				{!insightDetails && <p style={{ fontSize: 10, color: '#9e9e9e' }}>Data not available.</p>}
			</div>
        </Paper>
    </> 
}

function NumberOfControllers() {    
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [insightDetails, setInsightDetails] = useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [selectedCity, setSelectedCity] = React.useState("Select City");
  
    const open = Boolean(anchorEl);
  
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };
  
    const handleCityClick = (city) => {
      setSelectedCity(city);
      handleClose();
    };
  
    const getInsightDetails = () => {
      const params = { user_id: sessionStorage.getItem("user_id") };
      fetch(`${config.HOST_NAME}/crm/insights/controllers`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
          'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
        },
      })
        .then(response => {
          saveTokens(response);
          return response.json();
        })
        .then(json => {
          if (json.success) setInsightDetails(json.data);
          else notify(json.message, "warning");
        })
        .catch((error) => {
          notify("Something went wrong", "warning");
        })
        .finally(() => {
          setLoading(false);
        });
    };
  
    useEffect(() => {
      getInsightDetails();
    }, []);
  
    return (
      <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px" }}>
        <div style={{ flex: 1 }}>
          <div className={classes.headingContainer}>
            <Typography className={classes.showTitle}>Controllers</Typography>
            <div>
              <Button
                id="city-button"
                aria-controls={open ? "city-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                style={{
                  border: "1px",
                  color: "#5E8DD3",
                  backgroundColor: "#109CF11A",
                  fontSize: "10px",
                  fontWeight: "bold",
                  height: "30px",
                }}
              >
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <div style={{ marginTop: "3px" }}>{selectedCity} </div>
                  <div style={{ marginTop: "3px" }}><ArrowDropDownIcon /></div>
                </div>
              </Button>
              <Menu
                id="city-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "city-button",
                }}
              >
                <MenuItem onClick={() => handleCityClick("Delhi")}>Delhi</MenuItem>
                <MenuItem onClick={() => handleCityClick("Hyderabad")}>Hyderabad</MenuItem>
                <MenuItem onClick={() => handleCityClick("Noida")}>Noida</MenuItem>
                <MenuItem onClick={() => handleCityClick("Chandigarh")}>Chandigarh</MenuItem>
              </Menu>
            </div>
          </div>
          {!loading && insightDetails ? <Table style={{ color: "#334D6E" }}>
            <TableHead>
              <TableRow>
                <TableCell>Site Types</TableCell>
                <TableCell>Online</TableCell>
                <TableCell>Offline</TableCell>
                <TableCell>Total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.entries(insightDetails.siteTypes).map(([siteType, data]) => (
                <TableRowDataController key={siteType} label={siteType} data={data} loading={loading} />
              ))}
              <TableRowDataController  label={"Total"} data={insightDetails.total} loading={loading} />
            </TableBody>
          </Table> : <Typography variant='subtitle2'>Loading...</Typography> }
        </div>
      </Paper>
    );
}
  


function NumberOfMonthlyPasses({ startTime, endTime }) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false)
  const [insightDetails, setInsightDetails] = useState(null)
  function startOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }
  
  // Function to get the end of the month for a given date
  function endOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999);
  }
  const getInsightDetails = () => {
  const currentDate = new Date(); // Get the current date
  const params = {
    startTime: startTime ,
    endTime: endTime ,
    user_id: sessionStorage.getItem("user_id")
  };

      setLoading(true)
      fetch(`${config.HOST_NAME}/crm/insights/pass?${queryString.stringify(params)}`, {
          method: 'GET',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
              'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
          },
      })
          .then(response => {
              saveTokens(response)
              return response.json()
          })
          .then(json => {
              if (json.success) setInsightDetails(json.data)
              else notify(json.message, "warning");
          })
          .catch((error) => {
              notify("Something went wrong", "warning");
          })
          .finally(() => {
              setLoading(false)
          })
  };

  useEffect(() => {
      getInsightDetails()
  }, [startTime, endTime])

  return (
    <Paper style={{ boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px" }}>
      <Typography className={classes.showTitle}>Monthly Pass</Typography>
      {!loading && insightDetails ? (
        <div style={{ marginTop: 15 }}>
          <div>
            <Typography variant='subtitle2' style={{color:"000000", marginLeft:15}}>Recharge</Typography>
            <div style={{ marginTop: 0, display: "flex" }}>
              <Card style={{ boxShadow: 'none', border: 'none' }}>
                <CardContent className={classes.cardContent}>
                  <div style={{ textAlign: "left" }}>
                    <Typography variant='subtitle1' style={{color:"#707683"}}>Transactions:</Typography>
                    <Typography variant='h6' style={{ color: '#18CC69', fontWeight:"500" }}>{insightDetails.recharge.count}</Typography>
                    <Typography style={{ fontSize: 13 ,color:"#A3BBD9"}}>Cash: <span style={{color:"#000000", marginLeft:15}}>{insightDetails.recharge.paymentTypes.cash.count}</span></Typography>
                    <Typography style={{ fontSize: 13 ,color:"#A3BBD9"}}>Digital: <span style={{color:"#000000", marginLeft:15}}>{insightDetails.recharge.paymentTypes.digital.count}</span></Typography>
                  </div>
                </CardContent>
              </Card>
  
              <Card style={{ boxShadow: 'none', border: 'none', marginLeft: 10 }}>
                <CardContent className={classes.cardContent}>
                  <div style={{ textAlign: "left" }}>
                    <Typography variant='subtitle1' style={{color:"#707683"}}>Amount:</Typography>
                    <Typography variant='h6' style={{ color: '#18CC69', fontWeight:"500" }}><span>&#8377;</span> {insightDetails.recharge.amount}</Typography>
                    <Typography style={{ fontSize: 13 ,color:"#A3BBD9"}}>Cash: <span style={{color:"#000000", marginLeft:15}}><span>&#8377;</span> {insightDetails.recharge.paymentTypes.cash.amount}</span></Typography>
                    <Typography style={{ fontSize: 13 ,color:"#A3BBD9"}}>Digital: <span style={{color:"#000000", marginLeft:15}}><span>&#8377;</span> {insightDetails.recharge.paymentTypes.digital.amount}</span></Typography>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
  
          <div>
            <Typography variant='subtitle2'style={{color:"000000", marginLeft:15}}>New Issued</Typography>
            <div style={{ marginTop: 5, display: 'flex', justifyContent: 'flex-start' }}>
              <Card style={{ boxShadow: 'none', border: 'none' }}>
                <CardContent className={classes.cardContent}>
                  <div style={{ textAlign: "left" }}>
                    <Typography variant='subtitle1' style={{color:"#707683"}}>Transactions:</Typography>
                    <Typography variant='h6' style={{ color: '#18CC69', fontWeight:"500" }}>{insightDetails.issue.count}</Typography>
                    <Typography style={{ fontSize: 13 ,color:"#A3BBD9"}}>Cash: <span style={{color:"#000000", marginLeft:15}}>{insightDetails.issue.paymentTypes.cash.count}</span></Typography>
                    <Typography style={{ fontSize: 13 ,color:"#A3BBD9"}}>Digital: <span style={{color:"#000000", marginLeft:15}}>{insightDetails.issue.paymentTypes.digital.count}</span></Typography>
                  </div>
                </CardContent>
              </Card>
  
              <Card style={{ boxShadow: 'none', border: 'none', marginLeft: 10 }}>
                <CardContent className={classes.cardContent}>
                  <div style={{ textAlign: "left" }}>
                    <Typography variant='subtitle1' style={{color:"#707683"}}>Amount:</Typography>
                    <Typography variant='h6' style={{ color: '#18CC69', fontWeight:"500" }}><span>&#8377;</span> {insightDetails.issue.amount}</Typography>
                    <Typography style={{ fontSize: 13 ,color:"#A3BBD9"}}>Cash: <span style={{color:"#000000", marginLeft:15}}> <span>&#8377;</span> {insightDetails.issue.paymentTypes.cash.amount}</span></Typography>
                    <Typography style={{ fontSize: 13 ,color:"#A3BBD9"}}>Digital: <span style={{color:"#000000", marginLeft:15}}><span>&#8377;</span> {insightDetails.issue.paymentTypes.digital.amount}</span></Typography>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      ) : (
        <Typography variant='subtitle2'>Loading...</Typography>
      )}
    </Paper>
    
  );
}

function NumberOfPermitPasses({ startTime, endTime }) {
    const classes = useStyles();
    const [loading, setLoading] = useState(false)
    const [insightDetails, setInsightDetails] = useState(null)

    const getInsightDetails = () => {
      const params = {
        startTime: startTime,
        endTime: endTime,
        user_id: sessionStorage.getItem("user_id")
      };
        setLoading(true)
        fetch(`${config.HOST_NAME}/crm/insights/permits?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) setInsightDetails(json.data)
                else notify(json.message, "warning");
            })
            .catch((error) => {
                notify("Something went wrong", "warning");
            })
            .finally(() => {
                setLoading(false)
            })
    };

    useEffect(() => {
        getInsightDetails()
    }, [startTime, endTime])

    return (
      <Paper style={{ boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px" }}>
        <Typography className={classes.showTitle}>Permit</Typography>
        {!loading && insightDetails ? (
          <div style={{ marginTop: 15 }}>
            <div>
              <Typography variant='subtitle2' style={{color:"000000", marginLeft:15}}>Recharge</Typography>
              <div style={{ marginTop: 0, display: "flex" }}>
                <Card style={{ boxShadow: 'none', border: 'none' }}>
                  <CardContent className={classes.cardContent}>
                    <div style={{ textAlign: "left" }}>
                      <Typography variant='subtitle1' style={{color:"#707683"}}>Transactions:</Typography>
                      <Typography variant='h6' style={{ color: '#18CC69', fontWeight:"500" }}>{insightDetails.recharge.count}</Typography>
                      <Typography style={{ fontSize: 13 ,color:"#A3BBD9"}}>Cash: <span style={{color:"#000000", marginLeft:15}}>{insightDetails.recharge.paymentTypes.cash.count}</span></Typography>
                      <Typography style={{ fontSize: 13 ,color:"#A3BBD9"}}>Digital: <span style={{color:"#000000", marginLeft:15}}>{insightDetails.recharge.paymentTypes.digital.count}</span></Typography>
                    </div>
                  </CardContent>
                </Card>
    
                <Card style={{ boxShadow: 'none', border: 'none', marginLeft: 10 }}>
                  <CardContent className={classes.cardContent}>
                    <div style={{ textAlign: "left" }}>
                      <Typography variant='subtitle1' style={{color:"#707683"}}>Amount:</Typography>
                      <Typography variant='h6' style={{ color: '#18CC69', fontWeight:"500" }}><span>&#8377;</span> {insightDetails.recharge.amount}</Typography>
                      <Typography style={{ fontSize: 13 ,color:"#A3BBD9"}}>Cash: <span style={{color:"#000000", marginLeft:15}}><span>&#8377;</span> {insightDetails.recharge.paymentTypes.cash.amount}</span></Typography>
                      <Typography style={{ fontSize: 13 ,color:"#A3BBD9"}}>Digital: <span style={{color:"#000000", marginLeft:15}}><span>&#8377;</span> {insightDetails.recharge.paymentTypes.digital.amount}</span></Typography>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
    
            <div>
              <Typography variant='subtitle2'style={{color:"000000", marginLeft:15}}>New Issued</Typography>
              <div style={{ marginTop: 5, display: 'flex', justifyContent: 'flex-start' }}>
                <Card style={{ boxShadow: 'none', border: 'none' }}>
                  <CardContent className={classes.cardContent}>
                    <div style={{ textAlign: "left" }}>
                      <Typography variant='subtitle1' style={{color:"#707683"}}>Transactions:</Typography>
                      <Typography variant='h6' style={{ color: '#18CC69', fontWeight:"500" }}>{insightDetails.issue.count}</Typography>
                      <Typography style={{ fontSize: 13 ,color:"#A3BBD9"}}>Cash: <span style={{color:"#000000", marginLeft:15}}>{insightDetails.issue.paymentTypes.cash.count}</span></Typography>
                      <Typography style={{ fontSize: 13 ,color:"#A3BBD9"}}>Digital: <span style={{color:"#000000", marginLeft:15}}>{insightDetails.issue.paymentTypes.digital.count}</span></Typography>
                    </div>
                  </CardContent>
                </Card>
    
                <Card style={{ boxShadow: 'none', border: 'none', marginLeft: 10 }}>
                  <CardContent className={classes.cardContent}>
                    <div style={{ textAlign: "left" }}>
                      <Typography variant='subtitle1' style={{color:"#707683"}}>Amount:</Typography>
                      <Typography variant='h6' style={{ color: '#18CC69', fontWeight:"500" }}><span>&#8377;</span> {insightDetails.issue.amount}</Typography>
                      <Typography style={{ fontSize: 13 ,color:"#A3BBD9"}}>Cash: <span style={{color:"#000000", marginLeft:15}}> <span>&#8377;</span> {insightDetails.issue.paymentTypes.cash.amount}</span></Typography>
                      <Typography style={{ fontSize: 13 ,color:"#A3BBD9"}}>Digital: <span style={{color:"#000000", marginLeft:15}}><span>&#8377;</span> {insightDetails.issue.paymentTypes.digital.amount}</span></Typography>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>
        ) : (
          <Typography variant='subtitle2'>Loading...</Typography>
        )}
      </Paper>
      
    );
}

function NumberOfUserAppFastagTransactions({ startTime, endTime }) {
      const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [insightDetails, setInsightDetails] = useState(null);
  
    const getInsightDetails = () => {
      const params = {
        startTime: startTime,
        endTime: endTime,
        user_id: sessionStorage.getItem("user_id")
      };
        setLoading(true)
        fetch(`${config.HOST_NAME}/crm/insights/fastagRecharge?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) setInsightDetails(json.data)
                else notify(json.message, "warning");
            })
            .catch((error) => {
                notify("Something went wrong", "warning");
            })
            .finally(() => {
                setLoading(false)
            })
    };

  
    useEffect(() => {
      getInsightDetails();
    }, [startTime, endTime]);
  
    // Define your average recharge size and recharge failure analysis logic here
  
    return (
      <Paper style={{boxShadow: "0px 4px 15px #0000001a"}} className={classes.paper}>
      <Typography className={classes.showTitle}>FASTag Recharge</Typography>

      {!loading && insightDetails ? <div>
        <div style={{ marginTop: 15, display: 'flex', justifyContent: 'flex-start', gap:30 }}>
          <div>
            <Typography variant='subtitle1' style={{color:"#707683"}}>Success Transaction</Typography>
            <Typography variant='h6' style={{ marginTop: 2, color: '#18CC69', fontWeight:"500" }}>
              {insightDetails.success.count}
            </Typography>
          </div>
          <div style={{ marginLeft: 30 }}>
            <Typography variant='subtitle1' style={{color:"#707683"}}>Success Amount</Typography>
            <Typography variant='h6' style={{ marginTop: 2, color: '#18CC69', fontWeight:"500" }}>
              <span>&#8377;</span> {insightDetails.success.amount}
            </Typography>
          </div>
          </div>
  
        <div style={{ marginTop: 20, display: 'flex', justifyContent:"space-around", gap:15 }}>
          <Card className={classes.card} style={{boxShadow: "0px 4px 15px #0000001a"}}>
            <CardContent className={classes.cardContent}>
            <div style={{textAlign: "left"}}>
              <Typography variant='subtitle1' style={{color:"#707683"}}>Failed Transactions:</Typography>
              <Typography variant='h6' style={{ marginTop: 1, color: '#E32636', fontWeight:"500" }}>{insightDetails.failed.count}</Typography>
              <Typography style={{fontSize:13, marginTop:2,color:"#A3BBD9"}}>Amount: <span style={{color:"#000000", marginLeft:15}}><span>&#8377;</span> {insightDetails.failed.amount}</span></Typography>
              <Typography style={{fontSize:13, marginTop:2,color:"#A3BBD9"}}>Negative Feedback: <span style={{color:"#000000", marginLeft:15}}>{insightDetails.failed.negative_feedbacks}</span></Typography>
              <Typography style={{fontSize:13,color:"#A3BBD9"}}>Positive Feedback: <span style={{color:"#000000", marginLeft:15}}>{insightDetails.failed.positive_feedbacks}</span></Typography>
              </div>
            </CardContent>
          </Card> 
  
          <Card className={classes.card} style={{boxShadow: "0px 4px 15px #0000001a"}}>
            <CardContent className={classes.cardContent}>
            <div style={{textAlign: "left"}}>
              <Typography variant='subtitle1' style={{color:"#707683"}}>Cancelled Transactions:</Typography>
              <Typography variant='h6' style={{ marginTop: 1, color: '#E32636', fontWeight:"500" }}>{insightDetails.cancelled.count}</Typography>
              <Typography style={{fontSize:13, marginTop:2,color:"#A3BBD9"}}>Amount: <span style={{color:"#000000", marginLeft:15}}><span>&#8377;</span> {insightDetails.cancelled.amount}</span></Typography>
              <Typography style={{fontSize:13, marginTop:2,color:"#A3BBD9"}}>Negative Feedback: <span style={{color:"#000000", marginLeft:15}}>{insightDetails.cancelled.negative_feedbacks}</span></Typography>
              <Typography style={{fontSize:13,color:"#A3BBD9"}}>Positive Feedback: <span style={{color:"#000000", marginLeft:15}}>{insightDetails.cancelled.positive_feedbacks}</span></Typography>
              </div>
            </CardContent>
          </Card> 

          <Card className={classes.card} style={{boxShadow: "0px 4px 15px #0000001a"}}>
            <CardContent className={classes.cardContent}>
            <div style={{ marginLeft: 120, marginTop: 35 }}>
            <Typography variant='subtitle1' style={{color:"#707683"}}>Avg. Recharge</Typography>
            <Typography variant='h6' style={{ marginTop: 2, color: '#18CC69', fontWeight:"500" }}>
              <span>&#8377;</span> {insightDetails.averageSuccessRecharge}
            </Typography>
          </div>
            </CardContent>
          </Card> 
  
          
        </div>
        </div> : <Typography variant='subtitle2'>Loading...</Typography>}
    </Paper>
      );
}


function LineChartView({prices, counts, timePeriod, timeFormat}) {
    const classes = useStyles();
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));
    const [dialogVisible, setDialogVisible] = useState(false);

    const categories = [...timePeriod].map((data) => timeFormat === 'hours' ? moment(data).format('HH:mm:A') : moment(data).format("MMM Do YY"))
    const priceOptions = {
        chart: {
            stacked: true,
            events: {
                mounted: function (chartContext, config) {
                    // You can perform any additional actions after the chart is mounted
                },
            },
            toolbar: {
                show: false
            }
        },
        xaxis: {
            categories: categories,
            title: {
                text: 'Time Period',
            },
        },
        yaxis: {
            title: {
                text: 'Amounts',
            },
        },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.9,
                stops: [0, 100],
            },
        },
        colors: ['#5E8DD3'],
    };

    const countOptions = {
        chart: {
            stacked: true,
            events: {
                mounted: function (chartContext, config) {
                    // You can perform any additional actions after the chart is mounted
                },
            },
            toolbar: {
                show: false
            }
        },
        xaxis: {
            categories: categories,
            title: {
                text: 'Time Period',
            },
        },
        yaxis: {
            title: {
                text: 'Counts',
            },
        },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.9,
                stops: [0, 100],
            },
        },
        colors: ['#FFA726'],
    };

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    return (
        <div style={{marginTop: 15}}>
            <IconButton onClick={openDialog} title='Chart View'>
                <AssessmentIcon style={{ color: "#18cc69" }} />
            </IconButton>

            <Dialog fullWidth open={dialogVisible} onClose={closeDialog} classes={{ paper: classes.fullWidthDialog }}>
                <div style={{ display:'flex' }}>
                    <ReactApexChart
                        options={priceOptions}
                        series={[{ name: 'Amounts', data: prices }]}
                        type="area"
                        height={350}
                    />

                    <ReactApexChart
                        options={countOptions}
                        series={[{ name: 'Counts', data: counts }]}
                        type="area"
                        height={350}
                    />
                </div>
            </Dialog>
        </div>
    );
}

function LineChartViewV2({ prices, counts, timePeriod, timeFormat }) {
    const classes = useStyles();
    const isSmallDevice = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  
    const categories = [...timePeriod].map((data) =>
      timeFormat === "hours"
        ? moment(data).format("HH:mm:A")
        : moment(data).format("MMM Do YY")
    );
  
    const priceOptions = {
      chart: {
        stacked: true,
        events: {
          mounted: function (chartContext, config) {
            // You can perform any additional actions after the chart is mounted
          },
        },
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        categories: categories,
        title: {
          text: "Time Period",
        },
      },
      yaxis: {
        title: {
          text: "Amounts",
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 100],
        },
      },
      colors: ["#5E8DD3"],
    };
  
    const countOptions = {
      chart: {
        stacked: true,
        events: {
          mounted: function (chartContext, config) {
            // You can perform any additional actions after the chart is mounted
          },
        },
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        categories: categories,
        title: {
          text: "Time Period",
        },
      },
      yaxis: {
        title: {
          text: "Counts",
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 100],
        },
      },
      colors: ["#FFA726"],
    };
  
    return (
      <div style={{ marginTop: 15 }}>
        <ReactApexChart
          options={priceOptions}
          series={[{ name: "Amounts", data: prices }]}
          type="area"
          height={350}
        />
  
        <ReactApexChart
          options={countOptions}
          series={[{ name: "Counts", data: counts }]}
          type="area"
          height={350}
        />
      </div>
    );
}

function NumberOfDashboardUsers() {    
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [insightDetails, setInsightDetails] = useState(null);

  const getInsightDetails = () => {
    const params = { user_id: sessionStorage.getItem("user_id") };
    fetch(`${config.HOST_NAME}/crm/insights/dashboardUsers`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
        'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
      },
    })
      .then(response => {
        saveTokens(response);
        return response.json();
      })
      .then(json => {
        if (json.success) setInsightDetails(json.data);
        else notify(json.message, "warning");
      })
      .catch((error) => {
        notify("Something went wrong", "warning");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getInsightDetails();
  }, []);

  return (
    <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px" }}>
      <div style={{ flex: 1 }}>
        <div className={classes.headingContainer}>
          <Typography className={classes.showTitle}>Dashboard Users</Typography>
        </div>
        <div style={{ marginTop: 20 }}>
        {!loading && insightDetails ? (
          <Table style={{color: "#334D6E"}}>
            <TableHead>
              <TableRow>
                <TableCell>User Types</TableCell>
                <TableCell>Users</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {insightDetails.users.map((user) => (
                <TableRowDashboardUsers key={user.user_type} label={user.user_type} data={user} loading={loading} />
              ))}
              <TableRowDashboardUsers label="Total" data={{ user_type: "Total", count: insightDetails.total }} loading={loading} />
            </TableBody>
          </Table>
        ) : (
          <Typography variant='subtitle2'>Loading...</Typography>
        )}</div>
      </div>
      
    </Paper>
  );
}

function NumberOfAppUsers() {    
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [insightDetails, setInsightDetails] = useState(null);

  const getInsightDetails = () => {
    const params = { user_id: sessionStorage.getItem("user_id") };
    fetch(`${config.HOST_NAME}/crm/insights/appUsers`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
        'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
      },
    })
      .then(response => {
        saveTokens(response);
        return response.json();
      })
      .then(json => {
        if (json.success) setInsightDetails(json.data);
        else notify(json.message, "warning");
      })
      .catch((error) => {
        notify("Something went wrong", "warning");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getInsightDetails();
  }, []);

  return (
    <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px" }}>
      <div style={{ flex: 1 }}>
        <div className={classes.headingContainer}>
          <Typography className={classes.showTitle}>App Users</Typography>
        </div>
        <div style={{ marginTop: 20 }}>
        {!loading && insightDetails ? <Table style={{color: "#334D6E"}}>
          <TableHead>
            <TableRow>
              <TableCell>Types</TableCell>
              <TableCell>Users</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRowAppUsers label="Only Permit" data={insightDetails.permit} loading={loading} />
            <TableRowAppUsers label="Only M. Pass" data={insightDetails.pass} loading={loading} />
            <TableRowAppUsers label="M.Pass + Permit" data={insightDetails.passPermit} loading={loading} />
            <TableRowAppUsers label="No Vehicle" data={insightDetails.noVehicle} loading={loading} />
            <TableRowAppUsers label="Total" data={insightDetails.total} loading={loading} />
          </TableBody>
        </Table> : <Typography variant='subtitle2'>Loading...</Typography>}</div>
      </div>
    </Paper>
  );
}

function NumberOfTransactions({ startTime, endTime }) {    
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [insightDetails, setInsightDetails] = useState(null);
  const [insightDetailsHeading, setInsightDetailsHeading] = useState(null);

  const getInsightDetails = () => {
    const params = {
      startTime: startTime,
      endTime: endTime,
      user_id: sessionStorage.getItem("user_id")
    };
    fetch(`${config.HOST_NAME}/crm/insights/fastagTransactions?${queryString.stringify(params)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
        'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
      },
    })
      .then(response => {
        saveTokens(response);
        return response.json();
      })
      .then(json => {
        if (json.success)
         {setInsightDetails(json.data)
          setInsightDetailsHeading(json.dataDescription);
        }
        else notify(json.message, "warning");
      })
      .catch((error) => {
        notify("Something went wrong", "warning");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getInsightDetails();
  }, [startTime, endTime]);

  return (
    <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px" }}>
    <div style={{ flex: 1 }}>
      <div className={classes.headingContainer} style={{display:"flex", flexDirection:"column"}}>
        <Typography className={classes.showTitle}>FASTag TRANSACTIONS</Typography>
        <Typography style={{fontSize:10, marginTop:"10"}}>{insightDetailsHeading ? insightDetailsHeading : ""}</Typography>
      </div>
      <div style={{ marginTop: 20 }}>
      {!loading && insightDetails ? <Table style={{color: "#334D6E"}}>
        <TableHead>
          <TableRow>
            <TableCell>Sites</TableCell>
            <TableCell>Transactions</TableCell>
            <TableCell>Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRowTransactions label={insightDetails[0].site_name} data={insightDetails[0]} loading={loading} />
          <TableRowTransactions label={insightDetails[1].site_name} data={insightDetails[1]} loading={loading} />
          <TableRowTransactions label={insightDetails[2].site_name} data={insightDetails[2]} loading={loading} />
          <TableRowTransactions label="Total" data={insightDetails[3]} loading={loading} />
        </TableBody>
      </Table> : <Typography variant='subtitle2'>Loading...</Typography>}</div>
    </div>
  </Paper>
  );
}

function NumberOfParkingTypes() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [insightDetails, setInsightDetails] = useState(null);

  const getInsightDetails = () => {
    const params = { user_id: sessionStorage.getItem("user_id") };
    fetch(`${config.HOST_NAME}/crm/insights/sites`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        RefreshToken: `Bearer ${sessionStorage.getItem("refresh_token")}`,
      },
    })
      .then((response) => {
        saveTokens(response);
        return response.json();
      })
      .then((json) => {
        if (json.success) setInsightDetails(json.data);
        else notify(json.message, "warning");
      })
      .catch((error) => {
        notify("Something went wrong", "warning");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getInsightDetails();
  }, []);

  return (
    <>
      <Paper
        style={{
          boxShadow: "0px 4px 15px #0000001a",
          padding: "14px 20px",
        }}
      >
        <div>
          <Typography className={classes.showTitle}>PARKINGS</Typography>

          {!loading && insightDetails ? (
            <TableContainer>
              <Table style={{color: "#334D6E"}}>
                <TableHead>
                  <TableRow>
                    <TableCell>Site Type / Configuration</TableCell>
                    <TableCell>Only ANPR</TableCell>
                    <TableCell>ANPR + RFID</TableCell>
                    <TableCell>Fastag</TableCell>
                    <TableCell>Only POS</TableCell>
                    <TableCell>Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRowDataParking label={insightDetails[0].site_type} data={insightDetails[0]} loading={loading} />
                  <TableRowDataParking label={insightDetails[1].site_type} data={insightDetails[1]} loading={loading} />
                  <TableRowDataParking label={insightDetails[2].site_type} data={insightDetails[2]} loading={loading} />
                  <TableRowDataParking label={insightDetails[3].site_type} data={insightDetails[3]} loading={loading} />
                  {/* <TableRowDataParking label={insightDetails[4].site_type} data={insightDetails[4]} isTotalRow /> */}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography variant="subtitle2">Loading...</Typography>
          )}
        </div>
      </Paper>
    </>
  );
}


function NumberOfEntryExitTransactions({ startTime, endTime }) {
    const classes = useStyles();
    const [loading, setLoading] = useState(false)
    const [insightDetails, setInsightDetails] = useState(null)
    const [insightDetailsHeading, setInsightDetailsHeading] = useState(null);

    const getInsightDetails = () => {
      const params = {
        startTime: startTime,
        endTime: endTime,
        user_id: sessionStorage.getItem("user_id")
      };
        setLoading(true)
        fetch(`${config.HOST_NAME}/crm/insights/transactions?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
              if (json.success)
              {
                setInsightDetails(json.data)
                setInsightDetailsHeading(json.dataDescription);
              }
                else notify(json.message, "warning");
            })
            .catch((error) => {
                notify("Something went wrong", "warning");
            })
            .finally(() => {
                setLoading(false)
            })
    };

    useEffect(() => {
        getInsightDetails()
    }, [startTime, endTime])

    return <>
    <Paper style={{ boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px" }}>
      <div className={classes.headingContainer} style={{display:"flex", flexDirection:"column"}}>
        <Typography className={classes.showTitle}>Entry/Exit   TRANSACTIONS</Typography>
        <Typography style={{fontSize:10, marginTop:"10"}}>{insightDetailsHeading ? insightDetailsHeading : ""}</Typography>
      </div>
      <div style={{ marginTop: 20 }}>
        {!loading && insightDetails ? (
          <Table style={{color: "#334D6E"}}>
            <TableHead>
              <TableRow>
                <TableCell>Transactions Types</TableCell>
                <TableCell>Entry</TableCell>
                <TableCell>Exit</TableCell>
                <TableCell>Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRowEntryExitTransactions label="Fastag" data={insightDetails[0]} loading={loading} />
              <TableRowEntryExitTransactions label="Pass" data={insightDetails[1]} loading={loading} />
              <TableRowEntryExitTransactions label="Permit" data={insightDetails[2]} loading={loading} />
              <TableRowEntryExitTransactions label="POS" data={insightDetails[3]} loading={loading} />
              <TableRowEntryExitTransactions label="Total" data={insightDetails[4]} loading={loading} />
            </TableBody>
          </Table>
        ) : (
          <Typography variant='subtitle2'>Loading...</Typography>
        )}
      </div>
    </Paper>
    </>
}

function TableRowDataParking({ label, data, loading }) {
    const classes = useStyles();

    return (
        <TableRow>
            <TableCell className={classes.summaryBoxLabel2}>{label}</TableCell>
            <TableCell>{data.anpr_only ? data.anpr_only : "-"}</TableCell>
            <TableCell>{data.anpr_and_rfid ? data.anpr_and_rfid : "-"}</TableCell>
            <TableCell>{data.fastag ? data.fastag : "-"}</TableCell>
            <TableCell>{data.pos_only ? data.pos_only : "-"}</TableCell>
            <TableCell>{data.total ? data.total : "-"}</TableCell>
        </TableRow>
    );
}

function TableRowDataController({ label, data, loading }) {
  const classes = useStyles();

  return (
    <TableRow>
      <TableCell className={classes.summaryBoxLabel2}>{label}</TableCell>
      <TableCell>{data ? data.online : "-"}</TableCell>
      <TableCell>{data ? data.offline : "-"}</TableCell>
      {/* Calculate and display the total */}
      <TableCell>{data ? data.online + data.offline : "-"}</TableCell>
    </TableRow>
  );
}

function TableRowEntryExitTransactions({ label, data, loading }) {
    const classes = useStyles();

    return (
        <TableRow>
            <TableCell className={classes.summaryBoxLabel2}>{label}</TableCell>
            <TableCell>{data.entry_count ? data.entry_count : "-"}</TableCell>
            <TableCell>{data.exit_count ? data.exit_count : "-"}</TableCell>
            <TableCell>{data.amount ? data.amount : "-"}</TableCell>
        </TableRow>
    );
}

function TableRowDashboardUsers({ label, data, loading }) {
  const classes = useStyles();

  if (!data) {
    return null; // Don't render anything if data is null
  }

  return (
    <TableRow>
      <TableCell className={classes.summaryBoxLabel2}>{label}</TableCell>
      <TableCell>{data.count ? data.count : "-"}</TableCell>
    </TableRow>
  );
}

function TableRowAppUsers({ label, data, loading }) {
  const classes = useStyles();

  if (!data) {
    return null; // Don't render anything if data is null
  }

  return (
    <TableRow>
      <TableCell className={classes.summaryBoxLabel2}>{label}</TableCell>
      <TableCell>{data ? data : "-"}</TableCell>
    </TableRow>
  );
}

function TableRowTransactions({ label, data, loading }) {
  const classes = useStyles();

  if (!data) {
    return null; // Don't render anything if data is null
  }

  return (
    <TableRow>
      <TableCell className={classes.summaryBoxLabel2}>{label}</TableCell>
      <TableCell>{data.count ? data.count : "-"}</TableCell>
      <TableCell>{data.amount ? data.amount : "-"}</TableCell>
    </TableRow>
  );
}

export default DashboardInsights;